<template>
    <div class="comment-form">
        <form @submit.prevent="sendComment()" class="form-horizontal control-left">
            <form-item
                field="comment"
                :form="form"
                help-block-class="col-sm-offset-4 col-sm-8"
                class="md:flex flex-wrap"
            >
                <div
                    class="mb-3"
                    :class="{
                        'col-sm-12': post_type === 'live',
                        'col-sm-4 md:text-right': post_type !== 'live',
                    }"
                >
                    <label class="control-label" :class="textColor">Kommentar</label>
                </div>
                <div
                    :class="{ 'col-sm-12': post_type === 'live', 'col-sm-8': post_type !== 'live' }"
                >
                    <textarea-autosized
                        v-model="form.comment"
                        class="form-control"
                        placeholder="Indtast din kommentar"
                        :disabled="!editable"
                    ></textarea-autosized>
                    <!-- Validation error messages -->
                    <div v-if="validationErrors.comment" class="mt-2">
                        <p v-for="(error, index) in validationErrors.comment"
                        :key="index"
                        class="text-red-500 text-sm">
                            {{ error }}
                        </p>
                    </div>
                </div>
            </form-item>
            <div class="mt-10 form-group" v-if="editable">
                <div
                    class="md:text-right mb-3"
                    :class="{ 'col-sm-12': post_type === 'live', 'col-sm-4': post_type !== 'live' }"
                ></div>
                <div
                    class="flex justify-between items-center"
                    :class="{ 'col-sm-12': post_type === 'live', 'col-sm-8': post_type !== 'live' }"
                >
                    <h3
                        v-if="history.length"
                        @click="toggleHistory"
                        :class="{ active: showHistory }"
                        class="comment-history-title flex items-center gap-2 text-uppercase text-2xl font-black tracking-wide not-italic text-black cursor-pointer"
                    >
                        Dialog
                        <svg
                            :class="{ 'rotate-180': showHistory }"
                            class="transition-transform duration-300"
                            width="21"
                            height="18"
                            viewBox="0 0 21 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M10.5 5.9539L5.223 15H15.777L10.5 5.9539ZM10.5 0L21 18H0L10.5 0Z"
                                fill="black"
                            />
                        </svg>
                    </h3>
                    <button class="btn btn-xl btn-load btn-success" :disabled="form.busy">
                        <span>{{ buttonText }}</span>
                    </button>
                </div>
            </div>
        </form>
        <div v-if="showHistory" class="comment-history mt-5 flex flex-wrap">
            <div v-for="comment in history" class="comment-item mb-3 w-full">
                <div
                    v-if="comment.brand_comment"
                    class="form-group  flex flex-nowrap"
                    :class="{ 'flex gap-4': post_type === 'live' }"
                >
                    <div
                        class="flex col-xs-3"
                        :class="{ 'col-sm-4 justify-end': post_type !== 'live' }"
                    >
                        <img
                            :src="job.jobable.brand.avatar_url"
                            alt="Brand Avatar"
                            class="flex w-16 h-16 rounded-full"
                        />
                    </div>
                    <div
                        class="col-xs-9"
                        :class="{
                            'flex-auto': post_type === 'live',
                            'col-sm-8': post_type !== 'live',
                        }"
                    >
                        <p>{{ comment.brand_comment }}</p>
                    </div>
                </div>
                <div
                    v-if="comment.influencer_comment"
                    class="form-group  flex flex-nowrap"
                    :class="{ 'flex gap-4': post_type === 'live' }"
                >
                    <div
                        class="flex  col-xs-3"
                        :class="{ 'col-sm-4 justify-end': post_type !== 'live' }"
                    >
                        <img
                            :src="job.influencer.avatar_url"
                            alt="Influencer Avatar"
                            class="flex w-16 h-16 rounded-full"
                        />
                    </div>
                    <div
                        class="col-xs-9"
                        :class="{
                            'flex-auto': post_type === 'live',
                            'col-sm-8': post_type !== 'live',
                        }"
                    >
                        <p>{{ comment.influencer_comment }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['job', 'user_type', 'editable', 'form_number', 'post_type'],
    data() {
        return {
            form: new SparkForm({
                comment: '',
                user_type: this.user_type,
                job_id: this.job.id,
                number: this.form_number,
                post_type: this.post_type,
            }),
            validationRules: {
                required: true,
            },
            validationErrors: {},
            history: [],
            showHistory: true,
            buttonText: 'Gem kommentar',
            textColor: this.user_type === 'brand' ? '!text-black' : '',
        }
    },
    async created() {
        await this.fetchComments()
    },
    methods: {
        validateComment() {
            const errors = []

            if (!this.form.comment || !this.form.comment.trim()) {
                errors.push('Dette felt må ikke være tomt')
            }

            return errors
        },
        validateForm() {
            this.validationErrors = {}
            let isValid = true

            const commentError = this.validateComment()
            if (commentError.length > 0) {
                this.$set(this.validationErrors, 'comment', commentError)
                isValid = false
            }

            return isValid
        },
        toggleHistory() {
            this.showHistory = !this.showHistory // Toggle comment history visibility
        },
        async fetchComments() {
            try {
                const response = await axios.get(
                    route('api.job.comments', [this.job.id, this.form_number + 1, this.post_type])
                )
                this.history = response.data
            } catch (error) {
                console.error('Error fetching comments:', error)
            }
        },
        sendComment() {
            if (!this.validateForm()) {
                return
            }
            Spark.sendFormData('post', route('api.job.postComment', [this.job.id]), this.form)
                .then(response => {
                    this.history.push(response)
                    this.showHistory = true
                    this.form.comment = ''
                    this.buttonText = 'Gemt!'
                    setTimeout(() => {
                        this.buttonText = 'Gem kommentar'
                    }, 2000)
                })
                .catch(error => {
                    console.error(error)
                })
        },
    },
    watch: {
        'form.comment': {
            deep: true,
            handler() {
                this.validationErrors = {}
            }
        }
    }
}
</script>

<style scoped>
.comment-history-title {
}
</style>
